module.exports = __webpack_public_path__ + "static/media/communityImage3.c92043a5.png";